import styles from './StarsFullThreeReviews.scss?inline';
import { createComponent, siteUrl } from '#utils/template.js';

export enum Variants {
  Light = 'widget-review-full-view-1',
  Dark = 'widget-review-full-view-2',
}

export interface Review {
  rating: number;
  name: string;
  comment: string;
}

export interface CreateStarsFullThreeReviewsComponentProps {
  variant: Variants;
  averageRating: number;
  reviews: Review[];
  numberOfReviews: number;
  reviewRef: string;
  allReviewsRef: string;
}

export function createStarsFullThreeReviewsComponent(props: CreateStarsFullThreeReviewsComponentProps): HTMLElement {
  const clampedRating = Math.max(0, Math.min(props.averageRating, 5));
  const widthPercentage = (100 / 5) * clampedRating;
  return createComponent(
    `<div class="widget widget-review-full ${props.variant}">
            <div class="widget-review-full__header">
                <img src="${siteUrl('/media/assets/img/logo.svg')}" alt="Stars" width="120" height="40">
                <div class="widget__stars widget__stars-big">
                    <div class="widget__stars-inner">
                        <img src="${siteUrl('/media/assets/img/stars-big-not-fill.svg')}" alt="Stars">
                        <div class="widget__stars-active" style="width: ${widthPercentage}%">
                            <img src="${siteUrl('/media/assets/img/stars-big-fill.svg')}" alt="Stars">
                        </div>
                    </div>
                </div>

                <span class="widget-review-full__text">
            <b>${props.averageRating}</b> based on <b>${props.numberOfReviews}</b> reviews
          </span>

                <a href="${props.allReviewsRef}" class="widget-review-full__btn">See all reviews</a>
            </div>

<ul class="widget-review-full__list">
  ${props.reviews
    .map(
      (review) => `
      <li class="widget-review-full-item">
          <div class="widget__stars">
              <div class="widget__stars-inner">
                  <img src="${siteUrl('/media/assets/img/stars-not-fill.svg')}" alt="">
                  <div class="widget__stars-active" style="width: ${(100 / 5) * Math.max(0, Math.min(review.rating, 5))}%">
                      <img src="${siteUrl('/media/assets/img/stars-fill.svg')}" alt="">
                  </div>
              </div>
          </div>

          <div class="widget-review-full-item__author">${review.name}</div>
          <p class="widget-review-full-item__text">${review.comment}</p>
          <button class="widget-review-full-item__btn">
              <a class="widget-review-full-item__link" href="${props.reviewRef}">Read more</a>
          </button>
      </li>
    `,
    )
    .join('')}
        </div>`,
    styles,
  );
}
